import { CalculationRequestDto } from './../CalculationRequestDto';
import { IBANDto } from './IBANDto';
import { BeneficiaryDto } from './BeneficiaryDto';
import { InsuranceDto } from './InsuranceDto';
import { PersonDto } from './PersonDto';
import { AddressDto } from './../AddressDto';
import { PledgeDto } from './PledgeDto';
import { CustomerDto } from './CustomerDto';
import { ProductTypeEnum } from '../../enums/ProductTypeEnum';
import { RelationTypeEnum } from '../../enums/RelationTypeEnum';
import { CalculationResponseResultPremiumDto } from '../calculation/CalculationResponseResultPremiumDto';
import { IntermediaryDto } from '../IntermediaryDto';

export class ApplicationDto {
  referenceId: string;
  bankAccount: IBANDto;
  standardBeneficiary: boolean;
  beneficiaries: BeneficiaryDto[];
  calculalation: CalculationRequestDto;
  dateOfCommencement: Date;
  insuranceMotivation: string;
  insurances: InsuranceDto[];
  insured1: PersonDto;
  insured1Premium: number;
  insured2: PersonDto;
  insured2Premium: number;
  movingHouseDate: Date;
  movingHouseAddress: AddressDto;
  mortgageRelated: boolean;
  pledged: boolean;
  pledge: PledgeDto;
  policyHolder1: CustomerDto;
  policyHolder2: CustomerDto;
  policyTerms: string;
  premiumPayer: CustomerDto;
  premiumSplit: boolean;
  productType: ProductTypeEnum;
  relationPolicyHolder1ToInsured1: RelationTypeEnum;
  relationPolicyHolder1ToInsured1OtherText: string;
  relationPolicyHolder2ToInsured2: RelationTypeEnum;
  relationPolicyHolder2ToInsured2OtherText: string;
  calculationResponse: CalculationResponseResultPremiumDto;
  calculationRequest: CalculationRequestDto;
  intermediary: IntermediaryDto;
  policyHolder2SameAsInsured2: boolean;
}
